import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasySupplierPreferredCategoriesTranslations = wrapTranslationsSchema({
	name: 'BuyEasySupplierPreferredCategoriesTranslations',
	title: 'Preferred Categories Section Translations',
	sanityId: 'buyeasy-supplierCategories',
	fields: {
		preferredSectionTitle: 'Preferred Supplier For',
		categoryCode: 'Category Code',
		categories: 'Categories',
		companyCodes: 'Company Code(s)',
		companyCode: 'Company Code',
		noCategories: 'No categories',
		status: 'Status',
		commentOnSupplierScope: 'Comments on Supplier scope',
		selectCompanyCodes: 'Select one or more Company Codes to see relevant Categories',
		noCompanyCodeSelected: 'No Company Code Selected',
		supplierNotPreferred:
			"Supplier doesn't have the User's company code and not preferred for ANY company code",
		supplierNotPreferredForCompanyCode: 'Supplier is not preferred for any Company Code',
		categoryDescriptions: 'More Information on Categories/CP Codes',
		commentOnSupplierScopeTooltip:
			'Provides further detail of the scope of goods or services provided by the supplier.  For questions, contact the Takeda Supplier Owner.',
	},
});
